module.exports = __webpack_public_path__ + "img/130.03ef4d8b.jpg";